export abstract class StringUtil {
    public static join(strs: Array<string>, delimiter: string): string {
        let returnStr: string = '';
        for (const str of strs) {
            if (this.isNotBlank(str)) {
                returnStr += str + delimiter;
            }
        }
        returnStr = returnStr.substring(0, returnStr.length - delimiter.length);
        return returnStr;
    }

    public static isBlank(str: string): boolean {
        return !str || '' === str;
    }

    public static isNotBlank(str: string): boolean {
        return !this.isBlank(str);
    }

    public static format(str: string, ...values: Array<string>): string {
        if (this.isBlank(str) || values.length <= 0) {
            return str;
        }
        values.forEach((value, idx) => {
            str = str.replace(`{${idx}}`, value);
        });
        return str;
    }

    public static isBlankWithTrim(str: string): boolean {
        return !str || '' === str || '' === str.trim();
    }

    public static isNotBlankWithTrim(str: string): boolean {
        return !this.isBlankWithTrim(str);
    }
}
